// Local imports
import * as event from '../../datalayer/event.js';
import { push_data_object } from '../../datalayer/gtm/gtm_push.js';

// ===========================================================================
// Globals
// ===========================================================================

// Module name
export const MODULE_NAME = 'gc_featuredproduct_datalayer';

export let global_vars = {};

// ===========================================================================
// gccat-cards card click datalayer
// ===========================================================================

function init_clickhandler(global) {
    let all_featured = global.document.querySelectorAll(
        'div.card--featuredproduct'
    );

    for (let card of all_featured) {
        let cardnum = card.dataset.cardnum;
        let button_id = `buttonid${cardnum}`;
        let select_id = `variantid${cardnum}`;
        let button = global.document.querySelector(`#${button_id}`);
        let select = global.document.querySelector(`#${select_id}`);

        card.addEventListener('click', event => {
            let utag_data = global.utag_data;

            if (button !== null && button.contains(event.target)) {
                // Stop the propagation of the click event
                // so that the card click isn't fired
                event.stopPropagation();
                onclick_button(global, utag_data, event.currentTarget);
            }

            // Only fire if the card itself was clicked and not one if its
            // sub-components eg drop down list or button
            else if (
                event.target !== select &&
                event.target.parentNode !== select
            ) {
                onclick_card(global, utag_data, event.currentTarget);
            }
        });
    }
}

function onclick_card(global, utag_data, card) {
    let cardnum = card.dataset.cardnum;

    let dataid = `dataid${cardnum}`;
    let data_store = card.querySelector(`#${dataid}`);
    let dataset = data_store.dataset;

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Product Click';
    utag_data['event_label'] = 'Featured Product Card Clicked';

    utag_data['product_price'] = dataset.price;
    utag_data['product_id'] = dataset.id;
    utag_data['product_name'] = dataset.name;
    utag_data['product_brand'] = dataset.brand;
    utag_data['product_variant'] = dataset.variant;
    utag_data['product_category'] = dataset.category;
    utag_data['product_quantity'] = '1';
    utag_data['product_list'] =
        'Gift Collection Collection Page Featured Gifts';
    utag_data['product_position'] = cardnum;
    utag_data['enh_action'] = 'click';

    //== gtm-push: Featured Gift Card clicked ==//
    let data_object = {
        event: 'select_item',
        ecommerce: {
            items: [
                {
                    item_name: dataset.name,
                    item_id: dataset.id,
                    price: dataset.price,
                    item_category: dataset.category,
                    item_variant: dataset.variant,
                    item_list_name: 'Featured Gift Products List',
                    index: cardnum,
                },
            ],
        },
    };
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.ProductClick);
}

function onclick_button(global, utag_data, card) {
    let cardnum = card.dataset.cardnum;

    let data_store = card.querySelector(`#dataid${cardnum}`);
    let dataset = data_store.dataset;

    let product_price = dataset.price;
    let product_variant = dataset.variant;

    let variant_element = card.querySelector(`#variantid${cardnum}`);
    if (variant_element) {
        let selected_index = variant_element.selectedIndex;
        let selected_variant = variant_element.options[selected_index];
        let selected_data = selected_variant.dataset;

        product_variant = selected_variant.attributes['value'].value;
        product_price = selected_data.price;
    }

    utag_data['event_category'] = 'Ecommerce';
    utag_data['event_action'] = 'Add to Cart';
    utag_data['event_label'] = 'Featured Product Card Added To Cart';

    utag_data['product_price'] = product_price;
    utag_data['product_id'] = dataset.id;
    utag_data['product_name'] = dataset.name;
    utag_data['product_brand'] = dataset.brand;
    utag_data['product_variant'] = product_variant;
    utag_data['product_category'] = dataset.category;
    utag_data['product_quantity'] = '1';
    utag_data['product_list'] = 'Featured Gift Products List';
    utag_data['product_position'] = cardnum;

    //== gtm-push: Featured Gift Card added to cart ==//
    let data_object = {
        event: 'add_to_cart',
        ecommerce: {
            items: [
                {
                    item_name: dataset.name,
                    item_id: dataset.id,
                    price: product_price,
                    item_brand: dataset.brand,
                    item_category: dataset.category,
                    item_variant: product_variant,
                    item_list_name: 'Featured Gift Products List',
                    quantity: '1',
                },
            ],
        },
    };
    push_data_object(data_object);

    event.dispatch(global, event.EventKind.ProductClickCartAdd);
}

// Stores the data for each featured product card into the
// global.productImpressions object, that originates from gtm_vars.js
function store_featured_impressions(global) {
    //== gtm-push: OGC Featured Product Impressions ==//
    // Get all featured gift cards
    let all_featured = global.document.querySelectorAll(
        'div.card--featuredproduct'
    );

    // Iterate through the cards and push data to object
    for (let card of all_featured) {
        let cardnum = card.dataset.cardnum;
        let data_store = card.querySelector(`#dataid${cardnum}`);
        let dataset = data_store.dataset;

        global.promotions.push({
            promotion_name: dataset.name,
            promotion_id: dataset.id,
            creative_name: dataset.category,
            creative_slot: 'featured_product',
        });

        global.uaProductImpressions.push({
            name: dataset.name,
            id: dataset.id,
            price: dataset.price,
            category: dataset.category,
            variant: dataset.variant,
            list: dataset.productlist,
            position: cardnum,
        });
    }
}

// Initialize module
export function initialize(global) {
    init_clickhandler(global);
    store_featured_impressions(global);
}
